import { Intercept } from './Intercept';

export default Intercept;
